
//登录
import login from './login.js'
//公司 (客户)
import company from './company.js'
//员工
import staff from './staff.js'
//frp 穿透
import frp from './frp.js'
//system 系统
import system from './system.js'
//software 软件版本
import software from './software.js'
//blacklist 黑名单
import blacklist from './blacklist.js'
//address 地址
import address from './address.js'
// 用户 权限
import permission from './permission.js'
// rsa加密密钥相关
import Cryptography from './Cryptography.js'
export default{
  ...login,
  ...staff,
  ...frp,
  ...system,
  ...software,
  ...company,
  ...blacklist,
  ...address,
  ...permission,
  ...Cryptography,
}
